let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c9Qqc")).then(() => parcelRequire('f0XYo'));